import React from 'react';
import { PurchasesView } from './PurchasesView';

/**
 * Purchases page container. No page-level provider today; each widget is
 * self-served. If filters or shared state appear later (period control,
 * branch picker), they belong in a `PurchasesProvider` mirroring
 * `SalesProvider` and wrap `<PurchasesView />` from here.
 */
export const Purchases: React.FC = () => <PurchasesView />;
